export const API_URL = "https://onusconsultancy.com/OnusAPI/api/v1/"

export const JobPost = "https://onusconsultancy.com/OnusAPI/SmartComponent/JobPost/"
export const AboutUs = "https://onusconsultancy.com/OnusAPI/SmartComponent/AboutUs/"
export const Testimonial = "https://onusconsultancy.com/OnusAPI/SmartComponent/Testimonial/"
export const Service = "https://onusconsultancy.com/OnusAPI/SmartComponent/Service/"
export const BannerImg = "https://onusconsultancy.com/OnusAPI/SmartComponent/Banner/"